<template>
  <div class="mobile_virtual">
    <myHeader />
    <!-- <div style="width: 100%; height: 40px"></div> -->
    <div class="banner">
      <!-- <img src="https://download.hecoos.com/enlightv/2025-17/95d0a747caa28067ea472a4a4101c177.png" alt="" /> -->

      <div>
        <p style="font-size: 26px; font-weight: 700" class="mobile_virtual_p">
          Virtual Production xR/VP
        </p>
        <p style="
            width: 100%;
            margin: 10px auto 0;
            font-size: 12px;
            color: #fff;
          " class="mobile_virtual_p1">
          Expanding the Horizons of Spatial Storytelling—Spatial Composition
          Technology with LED Screens as Shooting Backgrounds
        </p>
        <div class="callMe" @click="jumpTo('/en/CaseDemonstration#CallMe')">Contact us</div>
      </div>
    </div>



    <!-- 虚拟制作模块 -->
    <div class="create">
      <p style="font-size: 14px; font-weight: 500" class="create_p">About xR</p>
      <p style="
          font-size: 26px;
          margin: 10px 0 16px;
          color: #fff;
          text-align: left;
        " class="create_p1">
        Virtual Production: Real-World Applications of the Concept
      </p>
      <p class="text default_font">
        Applied in Film and TV Productions, Television Programs, and Events.xR
        leverages
        <span>real-time camera tracking, real-time rendering, and multi-screen
          playback management technologies</span>
        to ensure that the virtual scenes displayed on LED screens maintain
        accurate <span>three-point perspective</span> with the “real characters”
        in front of the screen from the camera's viewpoint. Meanwhile, the
        visuals beyond the LED screen are seamlessly integrated in real-time
        using <span>"foreground overlay"</span> (AR) technology. This ultimately
        places the “real characters” within a virtual world, achieving a
        seamless blend of <span>reality and virtuality</span> for stunning
        visual effects.
      </p>
      <!-- <img style="width: 100%; margin-top: 10px"
        src="https://download.hecoos.com/enlightv/2025-17/79d8c4bea12f4c06941e0a6affd2be81.png" alt="" /> -->
    </div>

    <div class="create_video">
      <video class="info_video"
             id="intro_video"
             muted src="https://download.hecoos.com/enlightv/2025-48/43229fc3e024f310da39d6dc08f17a55.mp4">
      </video>
    </div>

    <!-- 变革制作模块 -->
    <div class="transformation">
      <p style="color: #b3b3b3; font-size: 14px; margin-bottom: 10px" class="transformation_p">
        Why Choose Virtual Production?
      </p>
      <p style="font-size: 26px; font-weight: 700; color: #fff" class="transformation_p1">
        Transform Your Production
      </p>
      <transformationProductionSwitch />

      <!-- 2.5D拍摄方案模块 -->
      <div class="plan">
        <p style="font-size: 20px; font-weight: 700; margin: 10px 0 20px" class="plan_p">
          2.5D Shooting Solution
        </p>
        <p style="font-size: 12px; line-height: 20px" class="plan_p1">
          A hybrid approach combining 2D and 3D assets for scene
          construction.<br /><br />

          Utilizes layered images or dynamic content with transparency channels
          to represent different depths of field, including foreground,
          midground, and background elements.<br /><br />

          Compared to fully 3D scene production, 2.5D significantly reduces
          production complexity while remaining compatible with standard 3D
          workflows.<br /><br />

          Offers a lightweight and efficient solution for asset creation, ideal
          for teams experienced in 3D scene construction.
        </p>
        <button class="more-button">
          <!-- <p>了解更多</p> -->
          <router-link class="vir_a" to="/en/understand">Learn More</router-link>
        </button>
      </div>
    </div>

    <!-- 应用场景模块 -->
    <div class="application">
      <p style="font-size: 26px; font-weight: 700; margin-bottom: 10px" class="application_p">
        Application Scenarios
      </p>
      <p style="color: #b8b8b8; font-size: 14px" class="application_p1">
        Practical Applications of hecoos xR/VP
      </p>
      <!-- <mobileRenderBanner :applicationInfo="applicationInfo" /> -->
       <sceneBanner :applicationInfo="applicationInfo" />
    </div>

    <!-- 产品模块 -->
    <div class="product">
      <div class="tab">
        <p style="font-size: 16px" class="default_font tab_p">PRODUCT</p>
        <p style="font-size: 26px; font-weight: 700; margin-top: 8px; width:100%;text-align:center" class="tab_p1">
          Your Virtual Production Toolkit
        </p>
        <div class="switch" ref="switch_list">
          <!-- 为每个 span 绑定点击事件和动态类名 -->
          <span :class="{ select: currentTabIndex === 0 }" @click="selectTab(0)">
            Server-C
          </span>
          <span :class="{ select: currentTabIndex === 1 }" @click="selectTab(1)">
            Server-R
          </span>
          <span :class="{ select: currentTabIndex === 2 }" @click="selectTab(2)">
            Server-D
          </span>
          <div class="underline" :style="{
            width: underlineWidth + 'px',
            left: underlineLeft + 'px',
          }"></div>
        </div>
      </div>

      <!-- 产品内容部分 -->
      <div>
        <div class="content">
          <div class="studio" v-show="showContents[0]">
            <img src="https://download.hecoos.com/enlightv/2025-17/04d5ec07fa899de9a432f1229ce2e14a.png" alt="" />
            <div class="textContent">
              <p style="font-size: 20px; font-weight: 700" class="textContent_p">Server-C</p>
              <p class="p_item">
                As the "core hub" of the virtual production process, it can be
                professionally customized based on on-site requirements, making
                it an essential choice for your virtual production needs.
              </p>
              <button @click="jumpTo('/en/mediaServer?section=1#tab')">Learn More</button>
            </div>
          </div>
          <div class="studio" v-show="showContents[1]">
            <img src="https://download.hecoos.com/enlightv/2025-17/84ed7b41f8f729ee36615a27ffed63f9.png" alt="" />
            <div class="textContent">
              <p style="font-size: 20px; font-weight: 700" class="textContent_p">Server-R</p>
              <p class="p_item">
                When confronted with the heavy and complex real-time rendering tasks, the super rendering capability of
                hecoos Server-R can also provide thoughtful support for virtual content creators.
              </p>
              <button @click="jumpTo('/en/mediaServer?section=2#tab')">Learn More</button>
            </div>
          </div>
          <div class="studio" v-show="showContents[2]">
            <img src="https://download.hecoos.com/enlightv/2025-17/312c08f1ed29d3fb2bde6056292ed57a.png" alt="" />
            <div class="textContent">
              <p style="font-size: 20px; font-weight: 700" class="textContent_p">Server-D</p>
              <p class="p_item">
                Based on the hecoos workflow, we will manage and control every link from the conception of the
                performance to the final presentation as much as possible, thereby implementing the product design
                concept of "design is realization".
              </p>
              <button @click="jumpTo('/en/mediaServer?section=0#tab')">Learn More</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- 技术指南模块 -->
    <div class="mobile_creativity">
      <p style="font-size: 20px; margin-bottom: 10px; font-weight: 700" class="mobile_creativity_pp">
        Technical Guide
      </p>
      <p style="font-size: 12px" class="mobile_creativity_pp1">
        Learn why Extended Reality (xR) is the ultimate next-generation
        storytelling tool for live productions and the technologies that make it
        possible.
      </p>
      <!-- <button class="guidebook_btn">Download Guide</button> -->
      <a class="guidebook_btn" href="https://download.hecoos.com/hecoos/hecoosGuide.pdf" style="font-size:12px">Download Guide</a>
      <img width="100%" src="@/asset/mobile/virtual/guidebook.png" alt="" />
    </div>
    <!-- 我们正年轻模块 -->
    <div>
      <div class="carousel-content">
        <video class="video_young" autoplay loop muted playsinline webkit-playsinline x5-playsinline
               x-webkit-airplay="allow"
               src="https://download.hecoos.com/enlightv/2025-48/7aa35bc6bfbdb6acd299ab6414915a22.mp4"></video>
        <div class="carousel-overlay">
          <p class="carousel-title">Honkai lmpact 3 "Innocent Dream Song"</p>
          <button class="watch-movie-button" @click="showVideo">
            <img src="https://download.hecoos.com/enlightv/2025-37/9d124e6eba23d44a2c6f6cd6aa75901f.svg" alt="" />
            <p style="font-size: 12px; font-weight: 700">Watch the Video</p>
          </button>
        </div>
      </div>
    </div>
    <myCreativity :imgUrl="imgUrl" :btnColor="btnColor" />
    <myListen :listenList="listenList" />
    <myFooter />
    <videoPlayback v-if="showVideoPlayer" @close="handleCloseVideo" :videoUrl="videoUrl" />
  </div>
</template>

<script>
import myHeader from "@/components/en_mobile/myHeader.vue";
import myFooter from "@/components/en_mobile/myFooter.vue";
import sceneBanner from "@/components/en_mobile/scene_banner.vue";
import myCreativity from "@/components/en_mobile/myCreativity.vue";
import transformationProductionSwitch from "@/components/en_mobile/transformationProductionSwitch.vue";
import videoPlayback from "@/components/en_mobile/videoPlayback.vue";
import myListen from "@/components/en_mobile/myListen.vue";

import Swiper from "swiper";
import "swiper/css/swiper.min.css";
export default {
  data() {
    return {
      btnColor: '#7948ea',
      showVideoPlayer: false,
      videoUrl: 'https://download.hecoos.com/enlightv/2025-48/7aa35bc6bfbdb6acd299ab6414915a22.mp4',
      // 新增变量，用于记录当前选中的 tab 索引
      currentTabIndex: 0,
      underlineWidth: 0,
      underlineLeft: 0,
      // 新增数组，用于控制每个产品内容的显示状态
      showContents: [true, false, false, false],
      applicationInfo: [
        {
          imgUrl: 'https://download.hecoos.com/enlightv/2025-17/ee5f23b3104fb4be10721778c0a997c4.png',
          title: "Film and Television Productions",
          msg: "Create immersive 3D story scenes, using real-time fusion of virtual and real environments to tell stories. The previsualization workflow provides directors with an intuitive preview of shooting effects.",
        },
        {
          imgUrl: 'https://download.hecoos.com/enlightv/2025-17/a25155afdd5ee47a4ce313ed0edb8797.png',
          title: "TVC Advertising",
          msg: "Quickly build the shooting space required for advertising creativity, enabling efficient presentation of ideas.",
        },
        {
          imgUrl: 'https://download.hecoos.com/enlightv/2025-17/ad529ec82ee802875c26931e8fe7264e.png',
          title: "Broadcast Television Programs",
          msg: "hecoos brings a new, efficient, and organized experience to broadcast television program production through an integrated workflow, covering key aspects such as virtual special effects packaging, precise director switching, lighting synchronization with program content, and audio-visual playback control.",
        },
      ],
      imgUrl: 'https://download.hecoos.com/enlightv/2025-17/519b1d101bbfe0e2b5f382ad27d8202a.png',
      listenList: [
        {
          msg: `The hecoos XR Virtual Production System closely aligns with the innovative "Pre-Post Production" process, addressing nearly all potential issues from the very beginning. Automated technologies such as color calibration and tracking save time and effort, while the highly integrated system reduces the technical barriers for users, allowing for quick learning and easy operation.`,
          author: "Liu Chang",
          address:
            "Deputy Director, Virtual Production Laboratory, School of Drama and Film",
        },
        {
          msg: `"The Wanderer" is a brand-new attempt in the production mode of Chinese science fiction-themed films. A 90-minute film was completed with all its shooting work finished within just 12 days. This is also a remarkable feat in the production of science fiction-themed films. The virtual shooting process of hecoos provides a guarantee for more efficient filming and stunning visual presentation, making the entire production process very smooth and demonstrating the great potential of virtual shooting technology in science fiction-themed films.`,
          author: `Zou Jie  "The Wandering Stranger" Producer`,
        },
      ],
      is_video_play:false,
    };
  },
  components: {
    myHeader,
    myFooter,
    sceneBanner,
    myCreativity,
    transformationProductionSwitch,
    videoPlayback,
    myListen,
  },


  methods: {
    scrollVideoPlay() {
      if(this.is_video_play){return false}
      var scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
      const intro_video = document.getElementById('intro_video')
      if(intro_video ){
        if (scrollTop >= 300) {
          this.is_video_play = true
          intro_video.play()
        }
      }
    },
    jumpTo(path) {
      // console.log(path);
      this.$router.push(path)
    },
    // 显示视频播放器
    showVideo() {
      this.showVideoPlayer = true;
      document.body.style.overflow = 'hidden'; // 禁止页面滚动
    },
    // 处理关闭视频
    handleCloseVideo() {
      this.showVideoPlayer = false;
      document.body.style.overflow = 'auto'; // 恢复页面滚动
    },

    // 新增方法，用于处理 tab 切换
    selectTab(index) {
      this.currentTabIndex = index;
      // 重置所有内容的显示状态为 false
      this.showContents = this.showContents.map(() => false);
      // 将当前选中的内容显示状态设为 true
      this.showContents[index] = true;
      this.updateUnderlinePosition();
    },

    // 导航切换底部跟随
    updateUnderlinePosition() {
      const switchList = this.$refs.switch_list;
      if (switchList) {
        const span = switchList.querySelectorAll("span")[this.currentTabIndex];
        const switchListRect = switchList.getBoundingClientRect();
        const spanRect = span.getBoundingClientRect();

        // 获取 span 的左右 padding 值
        const computedStyle = window.getComputedStyle(span);
        const paddingLeft = parseFloat(computedStyle.paddingLeft);
        const paddingRight = parseFloat(computedStyle.paddingRight);

        // 计算去除 padding 后的宽度
        this.underlineWidth = spanRect.width - paddingLeft - paddingRight;
        // 计算去除 padding 后的左侧偏移量
        this.underlineLeft = spanRect.left - switchListRect.left + paddingLeft;
      }
    },
    // 文字宽度变化监听
    setupSpanResizeObservers() {
      const spans = this.$refs.switch_list.querySelectorAll("span");
      const resizeCallback = () => {
        this.updateUnderlinePosition();
      };
      spans.forEach((span) => {
        const observer = new ResizeObserver(resizeCallback);
        observer.observe(span);
      });
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.updateUnderlinePosition();
      this.setupSpanResizeObservers();
      window.addEventListener("resize", this.updateUnderlinePosition);
    });
    new Swiper(this.$refs.swiper, {
      autoplay: {
        delay: 2000,
        // 交互后保持自动播放
        disableOnInteraction: true,
      },
      pagination: {
        el: ".swiper-pagination",
        // 可点击
        clickable: true,
      },
      // 禁用滑动
      allowTouchMove: false,
    });
    window.addEventListener('scroll', this.scrollVideoPlay);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateUnderlinePosition);
    window.removeEventListener('scroll', this.scrollVideoPlay);
  },
};
</script>

<style lang="scss" scoped>
@import "@/styles/en_mobile/mobile_xty.scss";
.callMe {
      width: 80px;
      height: 30px;
      line-height: 30px;
      border-radius: 15px;
      background-color: #2a82e4;
      margin: 0 auto;
      color: white;
      text-align: center;
      margin-top: 20px;
      font-size: 12px;
      transition: 0.3s ease;
      cursor: pointer;
    }

    .callMe:hover {
      transform: scale(1.05);
      background-color: #fff;
      color: #2a82e4;
    }
     @media screen and (min-width: 768px) {
      .callMe {
      width: 180px;
      height: 50px;
      line-height: 50px;
      border-radius: 30px;
      background-color: #2a82e4;
      margin: 0 auto;
      margin-top: 20px;
      font-size: 18px;
      transition: 0.3s ease;
      cursor: pointer;
    }

    .callMe:hover {
      transform: scale(1.05);
      background-color: #fff;
      color: #2a82e4;
    }
    }

.create_video{
  width: 100%;
  background-color: #000;
  video,source{
    display: block;
    width: 100%;
    object-fit: cover;
  }
}
</style>
